// apps/client/src/components/Workspace/WorkspaceSettings/useShortcutsDialogShortcut.ts
import { useSetAtom, useAtomValue } from 'jotai'
import {
  workspaceChallengeAtom,
  workspaceSettingsOpenAtom,
  workspaceSettingsInitialTabAtom,
  workspaceTaskAtom,
} from '@/store/workspaceAtoms'
import { trackWorkspaceSettings } from '@/modules/workspaceSettingsAnalytics'
import { useShortcut } from '@/modules/Shortcuts'

/**
 * Cmd/Ctrl+/ — opens the workspace settings dialog deep-linked to the
 * Shortcuts panel. Does not toggle close (unlike Cmd+,) — pressing again
 * while open keeps the dialog open and re-asserts the Shortcuts tab.
 */
export const useShortcutsDialogShortcut = () => {
  const setOpen = useSetAtom(workspaceSettingsOpenAtom)
  const isOpen = useAtomValue(workspaceSettingsOpenAtom)
  const setInitialTab = useSetAtom(workspaceSettingsInitialTabAtom)
  const challenge = useAtomValue(workspaceChallengeAtom)
  const task = useAtomValue(workspaceTaskAtom)

  useShortcut({
    id: 'workspace.shortcuts.open',
    keys: { cmd: true, key: '/' },
    group: 'general',
    labelKey: 'common.shortcutsShortcutsOpen',
    handler: () => {
      const wasOpen = isOpen
      setInitialTab('shortcuts')
      setOpen(true)
      if (!wasOpen) {
        trackWorkspaceSettings('workspace_settings:open', {
          source: 'shortcut',
          challengeId: challenge?.id,
          taskId: task?.id,
        })
      }
    },
  })
}
